import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map } from 'rxjs/operators';
import GetVehiclesFilterValues from '../../models/vehicle/filters.model';

import { Observable } from 'rxjs/Observable';
import { getVehicleFilters } from '../../../graph-ql/queries';

@Injectable()
export class VehicleFiltersService {

  constructor(private apollo: Apollo) {
  }

  getFilters(): Observable<GetVehiclesFilterValues> {
    return this.apollo.query<GetVehiclesFilterValues>({
      query: getVehicleFilters
    }).pipe(map(result => result.data['getVehicleFilters']));
  }
}
